import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNumericFormat } from 'react-number-format';
import { TextField } from './TextField';
export const CurrencyTextField = ({ value, onChange, currency = 'USD', useCents, numericFormatProps, allowZeroFormatting = true, ...props }) => {
    const [formattedValue, setFormattedValue] = useState('');
    const { inputProps = {} } = props;
    const { format, removeFormatting } = useNumericFormat({
        value,
        thousandSeparator: true,
        decimalScale: 2,
        allowNegative: true,
        allowLeadingZeros: false,
        ...numericFormatProps,
    });
    useEffect(() => {
        if (formattedValue === '-0') {
            return;
        }
        if (value === 0 || formattedValue.endsWith('.') || formattedValue.endsWith('.0')) {
            if (allowZeroFormatting && value === 0 && !(formattedValue.endsWith('.') || formattedValue.endsWith('.0')))
                setFormattedValue('0');
            return;
        }
        if (value && format) {
            if (useCents) {
                // This round was incorrect and dropping the cents values when formatting.
                // This was due to rounding after dividing by 100.  We need to round before dividing by 100.
                // (Although the rounding is not needed at all since cents should always be a whole number and if it is not, it is an error.)
                const newValue = format(String(Math.round(value) / 100));
                setFormattedValue(newValue);
            }
            else {
                const newValue = format(value);
                setFormattedValue(newValue);
            }
        }
        else {
            setFormattedValue('');
        }
    }, [value, formattedValue]);
    const handleChange = (e) => {
        const inputValue = e.target.value;
        if (!removeFormatting || !format)
            return;
        const newValue = removeFormatting(inputValue);
        const newFormatted = format(newValue);
        const cleanValue = removeFormatting(newFormatted);
        setFormattedValue(newFormatted);
        if (useCents) {
            newValue
                ? onChange(Math.round(Number(cleanValue) * 100))
                : onChange('');
        }
        else {
            onChange(cleanValue);
        }
    };
    return (_jsx(TextField, { startAdornment: currency === 'USD' ? '$' : '', ...props, inputProps: {
            ...inputProps,
            value: formattedValue,
            onChange: handleChange,
        } }));
};
//# sourceMappingURL=CurrencyTextField.js.map